import React, { useEffect, useRef, useState } from 'react'
import { Add, Subtract } from '../../icons'
import styles from './DownloadAccordion.module.sass'

interface Props {
  className?: string
  id?: string
  label?: string
  isOpen?: boolean
  forceOpen?: boolean
  children?: React.ReactNode
  labelClassName?: string
  onClick?: () => void
  contentPosition?: 'top' | 'bottom'
}

const DownloadAccordion = (props: Props) => {
  const {
    id = undefined,
    label = undefined,
    children = undefined,
    contentPosition = 'bottom',
    isOpen = false,
    forceOpen = false,
    className = '',
    onClick = () => undefined,
    labelClassName = '',
  } = props

  const [open, setOpen] = useState(false)
  const [height, setHeight] = useState<number | undefined>(undefined)
  const innerContentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (isOpen) setOpen(true)
  }, [])

  useEffect(() => {
    if (!innerContentRef.current) return

    const updateHeight = () => {
      const newHeight = open ? innerContentRef.current?.scrollHeight : 0
      setHeight(newHeight)
    }

    updateHeight()
    // Update height on window resize
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [open, innerContentRef])

  return (
    <div
      className={`${styles.root} ${open ? styles['root--open'] : ''} ${
        forceOpen ? styles['root--forceOpen'] : ''
      } ${className}`}
    >
      {contentPosition === 'top' && (
        <div
          id={`${id}_panel`}
          aria-labelledby={`${id}_label`}
          className={styles.content}
          style={{
            height: height !== undefined ? `${height}px` : undefined,
          }}
        >
          <div className={styles.innerContent} ref={innerContentRef}>
            {children}
          </div>
        </div>
      )}
      <h3 id={`${id}_label`}>
        <button
          type="button"
          className={styles.trigger}
          onClick={() => {
            setOpen(!open)
            onClick()
          }}
          aria-expanded={open || forceOpen}
          aria-controls={`${id}_panel`}
        >
          <span className={labelClassName}>{label}</span>
          <span className={styles.arrow}>{open ? <Subtract /> : <Add />}</span>
        </button>
      </h3>
      {contentPosition === 'bottom' && (
        <div
          id={`${id}_panel`}
          aria-labelledby={`${id}_label`}
          className={styles.content}
          style={{
            height: height !== undefined ? `${height}px` : undefined,
          }}
        >
          <div className={styles.innerContent} ref={innerContentRef}>
            {children}
          </div>
        </div>
      )}
    </div>
  )
}

export default DownloadAccordion
